import html2canvas from 'html2canvas';
import {jsPDF} from 'jspdf';
import {LatoRegular} from './report/Lato-Regular';
import CommonReportUtils from './report/CommonReportUtils';
import {logo} from './report/logo';
import StringUtils from './StringUtils';
import {LatoBold} from './report/Lato-Bold';
import {LatoItalic} from './report/LatoItalic';
import {LatoBoldItalic} from './report/Lato-BoldItalic';
export const handleDownloadPdf = async (request, handlers) => {
    handlers.onBefore();
    const element = request.refToPrint;
    const wrapperID = 'print-wrapper-id';
    const wrapper = document.createElement('div');
    const clonedNode = element.cloneNode(true);
    clonedNode.id = wrapperID;
    clonedNode.setAttribute('width', '300px');
    clonedNode.setAttribute('height', '300px');
    clonedNode.style.width = '300px';
    clonedNode.style.height = '300px';
    clonedNode.style = null;
    wrapper.appendChild(clonedNode);

    document.body.appendChild(wrapper);

    await html2canvas(wrapper)
        .then((canvas) => {
            if (canvas) {
                const data = canvas.toDataURL('image/jpeg', 1.0);
                callAddFontToDoc('lato', 'normal', LatoRegular);
                callAddFontToDoc('lato', 'bold', LatoBold);
                callAddFontToDoc('lato', 'italic', LatoItalic);
                callAddFontToDoc('lato', 'bold-italic', LatoBoldItalic);
                document.body.querySelectorAll(`[id='${wrapperID}']`).forEach((el) => el.remove());

                const doc = new jsPDF();

                const margin = CommonReportUtils.margin;
                let currentY = 15;
                const pageWidth = 195;
                const imageHeight = 31;
                doc.addImage(logo, 'SVG', margin / 2, currentY, 60, imageHeight);

                doc.setFont('lato', 'normal');
                doc.setFontSize(14);
                if (!StringUtils.isBlank(request.title)) {
                    currentY += CommonReportUtils.displayLongString(
                        request.title,
                        margin / 2,
                        margin / 2 + imageHeight + currentY,
                        pageWidth,
                        12,
                        doc
                    );
                } else {
                    currentY += margin / 2 + imageHeight + currentY;
                }

                doc.setFontSize(12);

                const labelY = currentY;
                const dateY = CommonReportUtils.displayLongString(request.activeFromLabel, margin / 2, labelY, 195, 12, doc);
                CommonReportUtils.displayLongString(request.activeToLabel, margin / 2 + 195 / 2, labelY, 195, 12, doc);

                currentY = CommonReportUtils.displayLongString(request.activeFrom, margin / 2, dateY, 195, 12, doc);
                CommonReportUtils.displayLongString(request.activeTo, margin / 2 + 195 / 2, dateY, 195, 12, doc);

                currentY = CommonReportUtils.displayLongString(request.descriptionLabel, margin / 2, currentY, 195, 12, doc);

                currentY = CommonReportUtils.displayHtml(
                    request.description,
                    CommonReportUtils.margin / 2,
                    currentY,
                    210 - CommonReportUtils.margin,
                    CommonReportUtils.lineHeight,
                    doc
                );

                const imgProperties = doc.getImageProperties(data);
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

                currentY = CommonReportUtils.addPageIfContentToLong(currentY, pdfHeight + margin, doc);
                doc.addImage(data, 'PNG', margin / 2, currentY, pdfWidth, pdfHeight);
                doc.save(request.fileName);
                handlers.onFinish();
            }
        })
        .catch((err) => {
            console.log(err);
            handlers.handleError();
        });
};
function callAddFontToDoc(fontName, fontType, font) {
    var callAddFont = function () {
        this.addFileToVFS(`${fontName}-${fontType}.ttf`, font);
        this.addFont(`${fontName}-${fontType}.ttf`, fontName, fontType);
    };
    jsPDF.API.events.push(['addFonts', callAddFont]);
}
